(function () {
  if (window.__czInit) return;
  window.__czInit = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('cz-js');
  var SEL = '.cz:not(.cz-hero) .cz__h2, .cz:not(.cz-hero) .cz__card, .cz:not(.cz-hero) .cz__faq, .cz:not(.cz-hero) .cz__col, .cz__cmp';
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      io.unobserve(el);
      el.classList.add('is-in');
      setTimeout(function () {
        el.classList.remove('cz-reveal', 'is-in');
        el.style.transitionDelay = '';
      }, 1400);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function scan(root) {
    (root || document).querySelectorAll(SEL).forEach(function (el) {
      if (el.dataset.czSeen) return;
      el.dataset.czSeen = '1';
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) return;
      var index = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.transitionDelay = Math.min(index, 5) * 90 + 'ms';
      el.classList.add('cz-reveal');
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
